import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const RulerIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <g clipPath="url(#clip0_102_72)">
        <path
          d="M2.10004 16.9L16.9 2.1"
          stroke={color}
          strokeWidth={strokeWidth || 1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.9 7.1L7.10004 21.9"
          stroke={color}
          strokeWidth={strokeWidth || 1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.1 2.1L21.9 4.9"
          stroke={color}
          strokeWidth={strokeWidth || 1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 4.8L16.4 6.2"
          stroke={color}
          strokeWidth={strokeWidth || 1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.6 8.2L13 9.6"
          stroke={color}
          strokeWidth={strokeWidth || 1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.20001 11.6L9.60001 13"
          stroke={color}
          strokeWidth={strokeWidth || 1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.80005 15L6.20005 16.4"
          stroke={color}
          strokeWidth={strokeWidth || 1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.9 2.1C17.5 1.5 18.5 1.5 19.1 2.1"
          stroke={color}
          strokeWidth={strokeWidth || 1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.10002 19.1C1.50002 18.5 1.50002 17.5 2.10002 16.9"
          stroke={color}
          strokeWidth={strokeWidth || 1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.10002 21.9C6.50002 22.5 5.50002 22.5 4.90002 21.9"
          stroke={color}
          strokeWidth={strokeWidth || 1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.9 4.9C22.5 5.5 22.5 6.5 21.9 7.1"
          stroke={color}
          strokeWidth={strokeWidth || 1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.90004 21.9L2.10004 19.1"
          stroke={color}
          strokeWidth={strokeWidth || 1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_102_72">
          <rect width="24" height="24" fill={color} />
        </clipPath>
      </defs>
    </BaseIcon>
  ),
);

RulerIcon.displayName = 'RulerIcon';
